import { makeStyles } from '@material-ui/core';
import icon from '../../assets/logo/icon-ld-dark.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

// Иконка livedigital для свёрнутого тёмного меню.
const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={icon} alt="livedigital" />;
};

export default LogoIcon;
